import { render, staticRenderFns } from "./Bbsbook.vue?vue&type=template&id=dd4b1c6a&scoped=true&"
import script from "./Bbsbook.vue?vue&type=script&lang=js&"
export * from "./Bbsbook.vue?vue&type=script&lang=js&"
import style0 from "./Bbsbook.vue?vue&type=style&index=0&id=dd4b1c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4b1c6a",
  null
  
)

export default component.exports